const translation = {
  pageTitle: 'Xin chào, hãy bắt đầu! 👋',
  welcome: 'Chào mừng bạn đến với Dify, vui lòng đăng nhập để tiếp tục.',
  email: 'Địa chỉ email',
  emailPlaceholder: 'Nhập email của bạn',
  password: 'Mật khẩu',
  passwordPlaceholder: 'Nhập mật khẩu của bạn',
  name: 'Tên người dùng',
  namePlaceholder: 'Nhập tên người dùng của bạn',
  forget: 'Quên mật khẩu?',
  signBtn: 'Đăng nhập',
  installBtn: 'Cài đặt',
  setAdminAccount: 'Thiết lập tài khoản quản trị',
  setAdminAccountDesc: 'Tài khoản quản trị có quyền tối đa, có thể tạo ứng dụng và quản lý các nhà cung cấp LLM, v.v.',
  createAndSignIn: 'Tạo và đăng nhập',
  oneMoreStep: 'Còn một bước nữa',
  createSample: 'Dựa trên thông tin này, chúng tôi sẽ tạo một ứng dụng mẫu cho bạn',
  invitationCode: 'Mã mời',
  invitationCodePlaceholder: 'Nhập mã mời của bạn',
  interfaceLanguage: 'Ngôn ngữ giao diện',
  timezone: 'Múi giờ',
  go: 'Đi đến Dify',
  sendUsMail: 'Gửi email giới thiệu cho chúng tôi, chúng tôi sẽ xử lý yêu cầu mời của bạn.',
  acceptPP: 'Tôi đã đọc và đồng ý với chính sách bảo mật',
  reset: 'Vui lòng chạy lệnh sau để đặt lại mật khẩu của bạn',
  withGitHub: 'Tiếp tục với GitHub',
  withGoogle: 'Tiếp tục với Google',
  rightTitle: 'Khai phá tiềm năng tối đa của LLM',
  rightDesc: 'Dễ dàng xây dựng ứng dụng AI hấp dẫn, có thể vận hành và cải thiện được.',
  tos: 'Điều khoản dịch vụ',
  pp: 'Chính sách bảo mật',
  tosDesc: 'Bằng cách đăng ký, bạn đồng ý với',
  goToInit: 'Nếu bạn chưa khởi tạo tài khoản, vui lòng chuyển đến trang khởi tạo',
  dontHave: 'Chưa có tài khoản?',
  invalidInvitationCode: 'Mã mời không hợp lệ',
  accountAlreadyInited: 'Tài khoản đã được khởi tạo',
  forgotPassword: 'Quên mật khẩu?',
  resetLinkSent: 'Đã gửi liên kết đặt lại mật khẩu',
  sendResetLink: 'Gửi liên kết đặt lại mật khẩu',
  backToSignIn: 'Quay lại đăng nhập',
  forgotPasswordDesc: 'Vui lòng nhập địa chỉ email của bạn để đặt lại mật khẩu. Chúng tôi sẽ gửi cho bạn một email hướng dẫn cách đặt lại mật khẩu.',
  checkEmailForResetLink: 'Vui lòng kiểm tra email để nhận liên kết đặt lại mật khẩu. Nếu không thấy trong vài phút, hãy kiểm tra thư mục spam.',
  passwordChanged: 'Đăng nhập ngay',
  changePassword: 'Đổi mật khẩu',
  changePasswordTip: 'Vui lòng nhập mật khẩu mới cho tài khoản của bạn',
  invalidToken: 'Mã thông báo không hợp lệ hoặc đã hết hạn',
  confirmPassword: 'Xác nhận mật khẩu',
  confirmPasswordPlaceholder: 'Nhập lại mật khẩu mới của bạn',
  passwordChangedTip: 'Mật khẩu của bạn đã được thay đổi thành công',
  error: {
    emailEmpty: 'Vui lòng nhập địa chỉ email',
    emailInValid: 'Vui lòng nhập một địa chỉ email hợp lệ',
    nameEmpty: 'Vui lòng nhập tên',
    passwordEmpty: 'Vui lòng nhập mật khẩu',
    passwordInvalid: 'Mật khẩu phải chứa cả chữ và số, và có độ dài ít nhất 8 ký tự',
    passwordLengthInValid: 'Mật khẩu phải có ít nhất 8 ký tự',
    registrationNotAllowed: 'Không tìm thấy tài khoản. Vui lòng liên hệ với quản trị viên hệ thống để đăng ký.',
  },
  license: {
    tip: 'Trước khi bắt đầu sử dụng Phiên bản Cộng đồng của Dify, vui lòng đọc',
    link: 'Giấy phép mã nguồn mở trên GitHub',
  },
  join: 'Tham gia',
  joinTipStart: 'Mời bạn tham gia',
  joinTipEnd: 'đội ngũ tại Dify',
  invalid: 'Liên kết đã hết hạn',
  explore: 'Khám phá Dify',
  activatedTipStart: 'Bạn đã tham gia',
  activatedTipEnd: 'đội ngũ',
  activated: 'Đăng nhập ngay',
  adminInitPassword: 'Mật khẩu khởi tạo quản trị viên',
  validate: 'Xác thực',
  sso: 'Tiếp tục với SSO',
  checkCode: {
    checkYourEmail: 'Kiểm tra email của bạn',
    verify: 'Xác minh',
    resend: 'Gửi lại',
    didNotReceiveCode: 'Bạn không nhận được mã?',
    validTime: 'Lưu ý rằng mã có hiệu lực trong 5 phút',
    invalidCode: 'Mã không hợp lệ',
    verificationCode: 'Mã xác minh',
    useAnotherMethod: 'Sử dụng phương pháp khác',
    emptyCode: 'Mã là bắt buộc',
    verificationCodePlaceholder: 'Nhập mã gồm 6 chữ số',
    tips: 'Chúng tôi gửi mã xác minh đến <strong>{{email}}</strong>',
  },
  back: 'Lưng',
  withSSO: 'Tiếp tục với SSO',
  continueWithCode: 'Tiếp tục với mã',
  changePasswordBtn: 'Đặt mật khẩu',
  useVerificationCode: 'Sử dụng mã xác minh',
  noLoginMethodTip: 'Vui lòng liên hệ với quản trị viên hệ thống để thêm phương thức xác thực.',
  enterYourName: 'Vui lòng nhập tên người dùng của bạn',
  setYourAccount: 'Đặt tài khoản của bạn',
  backToLogin: 'Quay lại đăng nhập',
  noLoginMethod: 'Phương thức xác thực không được cấu hình',
  or: 'HOẶC',
  resetPasswordDesc: 'Nhập email bạn đã sử dụng để đăng ký trên Dify và chúng tôi sẽ gửi cho bạn email đặt lại mật khẩu.',
  usePassword: 'Sử dụng mật khẩu',
  resetPassword: 'Đặt lại mật khẩu',
  sendVerificationCode: 'Gửi mã xác minh',
  licenseInactive: 'Giấy phép không hoạt động',
  licenseLost: 'Mất giấy phép',
  licenseInactiveTip: 'Giấy phép Dify Enterprise cho không gian làm việc của bạn không hoạt động. Vui lòng liên hệ với quản trị viên của bạn để tiếp tục sử dụng Dify.',
  licenseExpired: 'Giấy phép đã hết hạn',
  licenseExpiredTip: 'Giấy phép Dify Enterprise cho không gian làm việc của bạn đã hết hạn. Vui lòng liên hệ với quản trị viên của bạn để tiếp tục sử dụng Dify.',
  licenseLostTip: 'Không thể kết nối máy chủ cấp phép Dify. Vui lòng liên hệ với quản trị viên của bạn để tiếp tục sử dụng Dify.',
  webapp: {
    noLoginMethod: 'Phương thức xác thực chưa được cấu hình cho ứng dụng web',
    noLoginMethodTip: 'Vui lòng liên hệ với quản trị viên hệ thống để thêm phương thức xác thực.',
    disabled: 'Xác thực webapp đã bị vô hiệu hóa. Vui lòng liên hệ với quản trị hệ thống để kích hoạt nó. Bạn có thể thử sử dụng ứng dụng trực tiếp.',
  },
}

export default translation
